import {
  Text,
  GreyGrey10,
  GreyGrey70,
  GreyGrey80,
  Primary13SemiBold,
  Primary13Regular,
  Flex,
  Grid
} from '@sequencehq/core-components'
import { ReactNode } from 'react'

export const ReadOnlyDetails = (props: { children: ReactNode }) => (
  <Flex
    flexDirection="column"
    gap="8px"
    data-testid="priceEditor.readOnlyDetails"
  >
    <Text {...Primary13SemiBold} color={GreyGrey80}>
      Details
    </Text>
    <Grid
      gridTemplateColumns="164px 1fr"
      columnGap="28px"
      rowGap="12px"
      borderRadius="6px"
      padding="12px 8px"
      backgroundColor={GreyGrey10}
      color={GreyGrey70}
      {...Primary13Regular}
    >
      {props.children}
    </Grid>
  </Flex>
)
